import { useEffect, useRef, useState } from 'react';
import { useStyles } from '../assets/LoginStyle.jsx';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import useGlobal from 'store/store.js';
import usePhoneVerification from '../hooks/usePhoneVerification.js';
//mui
import { Box, Button, Card, Container, Tab, Tabs, Typography } from '@mui/material';
//libs
import { Animated } from "react-animated-css";
import { useNavigate } from 'raviger';
//assets
import loginBg from '../assets/loginBg.png';
import wrongSmsCode from '../assets/wrongSmsCode.svg';
import MailSuccess from '../assets/MailSuccess.svg';
//components
import { VBox } from '../assets/SharedComponents';
import { IdPassProcess } from '../Components/Login/IdPassProcess.jsx';
import { SmsProcess } from '../Components/Login/SmsProcess.jsx';
import LoginPageHeadr from 'Components/Login/LoginPageHeadr.jsx';
import cantFindSVG from '../assets/cantFindSVG.svg';
import EmailTakenModal from 'Components/Login/EmailTakenModal.jsx';
import EmailEmptyModal from 'Components/Login/EmailEmptyModal.jsx';
//api
import GenericDialog from 'Components/Common/GenericDIalog.jsx';
import { Office365TabAuth0 } from 'Components/Login/Office365TabAuth0.jsx';
import { AzureAdAuth0Provider } from 'providers/AzureAdAuth0Provider';
import { RegisterStepper } from 'Components/Register/RegisterStepper.jsx';
import { feathersClient } from 'api/client';
import useAuth0Feathers from 'hooks/useAuth0Feathers.js';

export const Login = ({ guest }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const { sendOTP, formatPhoneNumber } = usePhoneVerification();
    const hookAUTH = useAuth0Feathers();
    const navigate = useNavigate();

    const [PhoneNumber, setPhoneValue] = useState({
        phone: "",
        fixedNumber: "",
        confirmationResult: {}
    });
    const [Verification, setVerificationProcess] = useState({ level: 1 });
    const [tabValue, setValue] = useState(1); // Default to SMS tab
    const [tribeUserTab, setTribeUserTab] = useState(false);
    const [busy, setBusy] = useState(false);
    const [noFoundParent, setNoFoundParents] = useState(false);
    const [errorDetails, setErrorDetails] = useState({ username: "", phone: "" });
    const [username, setUsername] = useState("");
    const [smsSendError, setSmsSendError] = useState(false);
    const [emailMask, setEmailMask] = useState("");
    const [emailSendedDialog, setEmailSendedDialog] = useState(false);

    const [LoginIdProcess, setLoginIdProcess] = useGlobal(
        state => state.LoginIdProcess,
        actions => actions.setLoginIdProcess
    );
    const [emailExsist, setEmailExsist] = useGlobal(
        state => state.emailExsist,
        actions => actions.setEmailExsist
    );
    const [emailEmpty, setEmailEmpty] = useGlobal(
        state => state.emailEmpty,
        actions => actions.setEmailEmpty
    );

    useEffect(() => {
        setLoginIdProcess(1);
    }, [tabValue]);

    // Global function to show MessageBox
    const handleNoMatchingParentFound = (username, phone) => {
        setVerificationProcess({ level: 1 });
        setErrorDetails({ username, phone });
        setNoFoundParents(true);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setVerificationProcess({ level: 1 });
    };

    // SMS Tab - Send OTP
    const handleVerificationProcess = async (e) => {
        if (Verification.level === 1) {
            // Sending code to phone
            setBusy(true);

            try {
                console.log('📱 Starting SMS verification process...');

                // Format phone number
                const formattedPhone = formatPhoneNumber(PhoneNumber.phone);

                console.log('📞 Formatted phone:', formattedPhone);

                // Check if user exists in system
                console.log('🔍 Checking user existence...');

                await hookAUTH.loginAnonymously();

                const resultCheck = await feathersClient.service('check-matching-parent').find({
                    query: {
                        username: username,
                        phonenumber: formattedPhone
                    }
                });

                await hookAUTH.logoutAnonymously();

                console.log('✅ User exists in system');

                // Send OTP via Auth0
                console.log('📱 Sending OTP...');

                await sendOTP(formattedPhone);

                console.log('✅ OTP sent successfully');

                // Move to verification level
                setVerificationProcess({ level: 2 });
                setPhoneValue({
                    ...PhoneNumber,
                    fixedNumber: formattedPhone
                });

            } catch (error) {
                console.error('❌ SMS verification failed:', error);

                if (error.data && error.data.noMatchingParentFound) {
                    // No matching parent for ID and phone number
                    handleNoMatchingParentFound(error.data.username, error.data.phone);
                } else if (error.message?.includes('No matching parent')) {
                    // Also handle this error format
                    handleNoMatchingParentFound(username, PhoneNumber.phone);
                } else {
                    // General SMS send error
                    setSmsSendError(true);
                    enqueueSnackbar(
                        error.message || t("sendCodeFailed") || "שליחת קוד נכשלה",
                        { variant: 'error' }
                    );
                }
            } finally {
                setBusy(false);
            }
        } else {
            // Move to next verification level
            setVerificationProcess((obj) => ({ level: obj.level + 1 }));
        }
    };

    // Login with magic link email
    const loginUserByEmail = async () => {
        try {
            setBusy(true);

            console.log('📧 Sending magic link email...');

            // Format phone number
            const formattedPhone = formatPhoneNumber(PhoneNumber.phone);

            // Check if user exists and get email
            await hookAUTH.loginAnonymously();

            const resultCheck = await feathersClient.service('check-matching-parent').find({
                query: {
                    username: username,
                    phonenumber: formattedPhone
                }
            });

            await hookAUTH.logoutAnonymously();

            const userMail = resultCheck.matchingParent[`Parent${resultCheck.idx}_Mail`];

            console.log('📧 User email:', userMail);

            // Send magic link via Auth0
            const result = await feathersClient.service('send-auth0-signin-email').create({
                username: username,
                email: userMail,
                phoneNumber: formattedPhone
            });

            console.log('✅ Magic link email sent');

            // Mask email for display
            const parts = userMail.split('@');
            const localPart = parts[0];
            const domainPart = parts[1];
            const maskedLocalPart = localPart.charAt(0) + '*'.repeat(localPart.length - 1);
            const maskedEmail = maskedLocalPart + '@' + domainPart;

            setEmailMask(maskedEmail);
            setEmailSendedDialog(true);

        } catch (error) {
            console.error('❌ Magic link email failed:', error);
            enqueueSnackbar(
                t("errorOccuredText") || "אירעה שגיאה",
                { variant: 'error' }
            );
        } finally {
            setBusy(false);
        }
    };

    const handleLinkFromDialog = () => {
        loginUserByEmail();
        setSmsSendError(false);
    };

    const changePhoneValue = (e, sProp) => {
        if (sProp === "confirmationResult") {
            setPhoneValue({ ...PhoneNumber, confirmationResult: e });
        } else if (sProp === "phone" && typeof e === 'object') {
            // Handle both event and value directly
            const value = e.target ? e.target.value : e.phone;
            setPhoneValue({ ...PhoneNumber, phone: value });
        } else {
            const value = e.target ? e.target.value : e;
            setPhoneValue({ ...PhoneNumber, [sProp]: value });
        }
    };

    const backToSMS = (e) => {
        handleChange(e, 1);
        setTribeUserTab(false);
    };

    const tribeTab = (e) => {
        handleChange(e, 2);
        setTribeUserTab(true);
    };

    const tabs = [t("idAndPass"), t("smsOTP")];
    const guestSteps = [t("phoneVerification"), t("watchActivity"), t("payment")];
    const containerSlideRef = useRef(null);

    const sxProps = {
        backgroundImage: `url(${loginBg})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    };

    return (
        <>
            <Box className={`${classes.height100} ${classes.AppBackground}`} style={{ minHeight: '50rem' }}>
                <LoginPageHeadr
                    tribeTab={tribeTab}
                    tribeUserTab={tribeUserTab}
                    backToSMS={backToSMS}
                    guest={guest}
                />

                <Box alignItems="center" display="flex" flexDirection="column">
                    {guest ? (
                        <>
                            <RegisterStepper aSteps={guestSteps} activeStep={1} guest={true} />
                            <Card className={classes.loginCard}>
                                <Box
                                    sx={{ height: { xs: '55%', lg: '60%', xl: '60%' }, marginTop: "3rem" }}
                                    className={`${classes.margin0_1} ${classes.SmsMinHeight} ${classes.guestLoginStyle}`}
                                >
                                    <VBox
                                        ref={containerSlideRef}
                                        className={classes.TabHeigth}
                                        value={1}
                                        index={1}
                                        style={{ textAlign: "center", alignItems: "center", marginTop: "3rem" }}
                                    >
                                        <SmsProcess
                                            handleNoMatchingParentFound={handleNoMatchingParentFound}
                                            changePhoneValue={changePhoneValue}
                                            PhoneNumber={PhoneNumber}
                                            username={username}
                                            setUsername={setUsername}
                                            containerSlideRef={containerSlideRef}
                                            handleVerificationProcess={handleVerificationProcess}
                                            Verification={Verification}
                                            busy={busy}
                                            loginUserByEmail={loginUserByEmail}
                                        />
                                    </VBox>
                                </Box>
                            </Card>
                        </>
                    ) : (
                        <>
                            {!tribeUserTab && (
                                <Tabs
                                    centered
                                    className={`${classes.TabStyle} ${classes.SelectedTab}`}
                                    defaultValue={0}
                                    value={tabValue}
                                    indicatorColor="transparent"
                                    onChange={handleChange}
                                >
                                    {tabs.map((tab, i) => <Tab label={tab} key={i} />)}
                                </Tabs>
                            )}

                            <Card
                                className={classes.loginCard}
                                sx={Verification.level === 1 && !tribeUserTab && LoginIdProcess === 1
                                    ? sxProps
                                    : { background: "#ffffff" }
                                }
                            >
                                <Animated animationOut="fadeInDown" animationOutDuration={3500} isVisible={true}>
                                    <Box
                                        sx={{ height: { xs: '55%', lg: '50%', xl: '50%' } }}
                                        className={`${classes.margin0_1} ${classes.SmsMinHeight}`}
                                    >
                                        <Box ref={containerSlideRef} className={classes.FatherTabsStyle}>
                                            {/* Login with ID and password Tab */}
                                            <TabPanel className={classes.TabHeigth} value={tabValue} index={0}>
                                                <Container>
                                                    <IdPassProcess
                                                        handleNoMatchingParentFound={handleNoMatchingParentFound}
                                                        changePhoneValue={changePhoneValue}
                                                        PhoneNumber={PhoneNumber}
                                                        containerSlideRef={containerSlideRef}
                                                    />
                                                </Container>
                                            </TabPanel>

                                            {/* Login with SMS Tab */}
                                            <TabPanel className={classes.TabHeigth} value={tabValue} index={1}>
                                                <Container>
                                                    <SmsProcess
                                                        handleNoMatchingParentFound={handleNoMatchingParentFound}
                                                        changePhoneValue={changePhoneValue}
                                                        PhoneNumber={PhoneNumber}
                                                        username={username}
                                                        setUsername={setUsername}
                                                        containerSlideRef={containerSlideRef}
                                                        handleVerificationProcess={handleVerificationProcess}
                                                        Verification={Verification}
                                                        busy={busy}
                                                        loginUserByEmail={loginUserByEmail}
                                                    />
                                                </Container>
                                            </TabPanel>

                                            {/* Login with Office365 tribe user */}
                                            <TabPanel
                                                mt={{ md: '1rem' }}
                                                className={classes.TabHeigth}
                                                value={tabValue}
                                                index={2}
                                            >
                                                <Container>
                                                    <AzureAdAuth0Provider>
                                                        <Office365TabAuth0
                                                            handleChange={handleChange}
                                                            setTribeUserTab={setTribeUserTab}
                                                        />
                                                    </AzureAdAuth0Provider>
                                                </Container>
                                            </TabPanel>
                                        </Box>
                                    </Box>

                                    {!tribeUserTab &&
                                        tabValue < 2 &&
                                        Verification.level === 1 &&
                                        LoginIdProcess !== 3 &&
                                        LoginIdProcess !== 2 && (
                                            <Box sx={{ height: '5%' }}>
                                                <ActionButtonRegister />
                                            </Box>
                                        )}
                                </Animated>
                            </Card>
                        </>
                    )}
                </Box>
            </Box>

            {/* Email Taken Modal */}
            <EmailTakenModal
                open={emailExsist}
                setOpen={setEmailExsist}
                PhoneNumber={PhoneNumber}
                username={username}
                backToSMS={backToSMS}
            />

            {/* Email Empty Modal */}
            <EmailEmptyModal
                open={emailEmpty}
                setOpen={setEmailEmpty}
                PhoneNumber={PhoneNumber}
                username={username}
                backToSMS={backToSMS}
            />

            {/* No Matching Parent Dialog */}
            <GenericDialog
                open={noFoundParent}
                setOpen={setNoFoundParents}
                iconSVG={cantFindSVG}
                height="23rem"
                showRopes={true}
            >
                <Container style={{ textAlign: "center" }}>
                    <Typography color="#064601" mt="1rem" variant="mediumBoldText">
                        {t('noFoundParentWithID')}
                    </Typography>
                    <Typography style={{ alignItems: "center", textAlign: "center" }}>
                        {t("toId")} <b>{errorDetails.username}</b>
                    </Typography>
                    <Typography style={{ alignItems: "center", textAlign: "center", direction: "rtl" }}>
                        {t("andPhone")} <b>{errorDetails.phone?.toString().slice(1) + '+'}</b>
                    </Typography>
                </Container>
                <VBox>
                    <Button
                        className={classes.buttonGreen}
                        onClick={() => {
                            setNoFoundParents(false);
                            navigate('/register/fparent');
                        }}
                    >
                        {t("continueToRegistration")}
                    </Button>
                    <Button
                        className={classes.buttonWhite}
                        onClick={() => setNoFoundParents(false)}
                    >
                        {t("tryAgain")}
                    </Button>
                </VBox>
            </GenericDialog>

            {/* SMS Send Error Dialog */}
            <GenericDialog
                open={smsSendError}
                setOpen={setSmsSendError}
                iconSVG={wrongSmsCode}
                height="21rem"
                width="32rem"
                showRopes={true}
            >
                <Typography color="#064601" mt="1rem" variant="mediumBoldText" textAlign="center">
                    {t('otherLoginMethod')}
                </Typography>
                <Typography color="#064601" mt="1rem" variant="mediumBoldText" textAlign="center">
                    {t('otherLoginMethod1')}
                </Typography>
                <Typography color="#064601" variant="mediumBoldText" textAlign="center">
                    {t('otherLoginMethod2')}
                </Typography>
                <Button
                    disabled={!PhoneNumber.phone || !username}
                    variant="contained"
                    onClick={handleLinkFromDialog}
                    sx={{ marginTop: "0.5rem" }}
                    className={!PhoneNumber.phone || !username ? classes.buttonGreenLight : classes.buttonGreen}
                >
                    {t("sendCodeToMyEmail")}
                </Button>
            </GenericDialog>

            {/* Email Sent Successfully Dialog */}
            <GenericDialog
                open={emailSendedDialog}
                setOpen={setEmailSendedDialog}
                iconSVG={MailSuccess}
                height="22rem"
                width="33rem"
                showRopes={true}
            >
                <Typography color="#064601" mt="1rem" variant="mediumBoldText" textAlign="center">
                    {t('mailSended')}!
                </Typography>
                <Typography color="#064601" mt="0.5rem" variant="dialogBoldText" textAlign="center">
                    {`${t('toEmailAddress')}-${emailMask}`}
                </Typography>
                <Typography color="red" variant="dialogBoldText" textAlign="center">
                    {`${t('expairedLink')}-${t('fifteenMintues')}`}
                </Typography>
                <Typography color="#064601" variant="dialogBoldText" textAlign="center">
                    {t('sendAgain')}
                </Typography>
            </GenericDialog>
        </>
    );
};

const TabPanel = ({ children, value, index, ...other }) => {
    const classes = useStyles();

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box height="100%" className={classes.BoxNoPaddingTopBottom} p={2}>
                    {children}
                </Box>
            )}
        </Box>
    );
};

const ActionButtonRegister = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const navigate = useNavigate();
    const [language] = useGlobal((state) => state.language);

    return (
        <Box display="flex" flexDirection="column">
            <Typography
                className={`${classes.fontBold} ${classes.CenterItems}`}
                style={{
                    fontSize: "1.3rem",
                    color: '#000',
                    direction: language === "he" ? "rtl" : "ltr"
                }}
                component="span"
            >
                {t("firstUse")}
                <Typography
                    className={`${classes.LinkStyle} ${classes.fontBold} ${classes.CenterItems}`}
                    onClick={() => navigate('/register/fparent')}
                    style={{ fontSize: "1.3rem", cursor: 'pointer' }}
                >
                    {t("toRegistration")}
                </Typography>
            </Typography>
        </Box>
    );
};